//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headers from '../../components/headers'

export default {
    components: {
        headers,
    },
    data () {
        return {
            model:{},
            bannerModel:[],
            serverCompanyModel:[],
            // HotGoodsList:[],
            appListModel:[],
            // paasListModel:[],
            // hardListModel:[],
            demandListModel:[]
        }
    },
    created(){
        this.getIndexBanner();//轮播图
        this.getPageUrlList();//服务商推荐
        // this.getHotGoodsList();//热销商品
        this.getAppGoodsShopList();//推荐应用
        // this.getSourceGoodsShopList()//推荐源码
        // this.getHardwareGoodsShopList()//推荐硬件
        this.getDemandShopList()//推荐需求

    },
    methods: {
          getIndexBanner(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getIndexBanner?type=2',this.model,{emulateJSON:true}).then(function(res){

                    if(res.body.success)
                    {
                      this.bannerModel= res.body.data
                    }
                },function(res){
            });
        },
          getPageUrlList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getPageUrlList?pageId=2&devPageAreaId=7',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                        this.serverCompanyModel= res.body.data
                        if(res.body.data.length>4){
                            for(var i=0;i<res.body.data.length;i++){
                                this.serverCompanyModel.splice(4, res.body.data.length);
                            }
                        }
                    }
                },function(res){
            });
        },
          getHotGoodsList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getHotGoodsList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      this.HotGoodsList= res.body.data
                    }
                },function(res){
            });
        },
        getAppGoodsShopList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getAppGoodsShopList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      this.appListModel= res.body.data
                    }
                },function(res){
            });
        },
         getSourceGoodsShopList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getSourceGoodsShopList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      this.paasListModel= res.body.data
                    }
                },function(res){
            });
        },
         getHardwareGoodsShopList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getHardwareGoodsShopList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    {
                      this.hardListModel= res.body.data
                    }
                },function(res){
            });
        },
         getDemandShopList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getDemandShopList',this.model,{emulateJSON:true}).then(function(res){
                   if(res.body.success)
                    {
                      this.demandListModel= res.body.data
                    }
                },function(res){
            });
        },
        open(url){
            // this.$router.push(url)
            if(url==null||url==""){
              return;
            }
             window.location.href=url;
        },
        openDetail(item){
            window.location.href="/m/mall/app/detail1.html?sourceAddress=1&goodsId="+item.goodsId;
        },
        hotClick(item){
            if(item.goodsPriceType==5){
                //  this.$router.push('/mall/hardware/detail?goodsId='+item.goodsId)
                window.location.href="/m/mall/hardware/detail.html?sourceAddress=1&goodsId="+item.goodsId;
            }else if(item.goodsPriceType==6){
                // this.$router.push('/mall/paas/detail?appId='+item.appId)
                window.location.href="/m/mall/paas/detail.html?sourceAddress=1&appId="+item.appId;
            }else{
                this.openDetail(item)
            }

        }
    }
}



// WEBPACK FOOTER //
// ./src/views/mall/mallIndex.vue